var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"slider-campanha"}},[_c('div',{staticClass:"slider-produtos-home"},_vm._l((_vm.produtos),function(item,index){return _c('ItemProduto',{key:index,attrs:{"item":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }